import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import Layout from '../../components/layout/Layout';
import ProjectGrid from '../../components/ProjectGrid';
import Button from '../../components/Button';

export default ({ location }) => {
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const filters = (urlParams.get('filters') || '').split(',');
    if (filters.length === 0) setFilter('all');
    if (filters.includes('app')) setFilter('app');
    if (filters.includes('web')) setFilter('web');
    if (filters.includes('it')) setFilter('it');
    if (filters.includes('video')) setFilter('video');
    if (filters.includes('audio')) setFilter('audio');
  }, []);

  const btnClassName = 'bg-gray-300 hover:bg-gray-400 font-bold py-2 px-4';

  return (
    <Layout location={location}>
      <div className="flex-wrap my-4 container mx-auto text-center">
        <div className="inline-flex">
          <Button
            className={cn(btnClassName, 'rounded-l')}
            notRounded
            isSelected={filter === 'all'}
            onClick={() => setFilter('all')}
          >
            All
          </Button>
          <Button
            className={btnClassName}
            isSelected={filter === 'app'}
            notRounded
            onClick={() => setFilter('app')}
          >
            Mobile Apps
          </Button>
          <Button
            className={btnClassName}
            notRounded
            isSelected={filter === 'web'}
            onClick={() => setFilter('web')}
          >
            Websites
          </Button>
          <Button
            className={btnClassName}
            isSelected={filter === 'it'}
            notRounded
            onClick={() => setFilter('it')}
          >
            IT &amp; Cloud Solutions
          </Button>
          <Button
            className={btnClassName}
            isSelected={filter === 'video'}
            notRounded
            onClick={() => setFilter('video')}
          >
            Video
          </Button>
          <Button
            className={cn(btnClassName, 'rounded-r')}
            isSelected={filter === 'audio'}
            notRounded
            onClick={() => setFilter('audio')}
          >
            Audio
          </Button>
        </div>
      </div>
      <section className="">
        <ProjectGrid filterTypes={filter === 'all' ? [] : [filter]} />
      </section>
    </Layout>
  );
};
